import dayjs from "dayjs";

export const updateDayjsGlobalLocale = (userLocale: string | undefined) => {
  if (userLocale) {
    const setValue = dayjs.locale(userLocale);
    if (setValue !== userLocale) {
      dayjs.locale(userLocale.split("-")[0]);
    }
  }
};
